import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-blue-950 px-4 pb-7 pt-6 text-center md:px-10" data-id="element-85" data-mp="28tuwyyf555f7">
      <h1 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-white md:text-4xl" data-id="element-86" data-mp="28vzc6cihpqus">
        <ZapIcon className="mr-1 inline h-6 w-6 -translate-y-1 fill-amber-400 text-amber-400 md:h-8 md:w-8" aria-hidden data-id="element-87" data-mp="30lau3mebqajo" />
        El sistema completo de <span className="text-sky-400" data-id="element-88" data-mp="2msuku3utxgab">diagnóstico y soluciones eléctricas</span>, listo para
        usar.
      </h1>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-snug text-white md:text-base" data-id="element-89" data-mp="2rrfpcfh46m4k">
        Dejá de perder tiempo intentando identificar fallas eléctricas sin contar con una guía organizada de consulta.
      </p>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-slate-300 md:text-base" data-id="element-90" data-mp="3kbe9jhem2kqf">
        Accedé a casos prácticos de diagnóstico, soluciones explicadas paso a paso, diagramas eléctricos, ejemplos de
        mediciones, fichas de inspección y herramientas para preparar presupuestos profesionales.
      </p>
      <p className="mx-auto mt-2 max-w-xl text-sm font-bold leading-snug text-white md:text-base" data-id="element-91" data-mp="2kelijiha1m04">
        Todo organizado en un solo sistema para electricistas domiciliarios que quieren trabajar con mayor seguridad,
        criterio técnico y organización.
      </p>
      <p className="mt-2 text-xs font-bold uppercase leading-tight text-amber-400 md:text-sm" data-id="element-92" data-mp="2u452krgq7lwk">
        Menos tiempo buscando información. Más herramientas para resolver cada trabajo.
      </p>

      <div className="mx-auto mt-4 max-w-[320px]" data-id="element-93" data-mp="335w5xpnsngn9">
        <ProductImage data-id="element-94" data-mp="1dpmxtvh5k9ps" />
      </div>

      <p className="mt-3 text-xl font-extrabold uppercase leading-tight text-white md:text-2xl" data-id="element-95" data-mp="1dqonb4yx0yr1">
        Combo Completo <span className="text-amber-400" data-id="element-96" data-mp="18swijad69i5f">Electricistas</span>
      </p>
      <p className="mx-auto mt-1 max-w-md text-sm font-semibold leading-snug text-sky-300" data-id="element-97" data-mp="38ucvioqya9jf">
        El sistema profesional 4 en 1 para diagnóstico de fallas y soluciones eléctricas.
      </p>
      <p className="mt-2 text-xs font-extrabold uppercase tracking-wide text-amber-400 md:text-sm" data-id="element-98" data-mp="3ir94swooazp1">
        4 tomos principales + 4 bonos profesionales
      </p>
      <p className="mt-1 text-xs font-bold uppercase text-white" data-id="element-99" data-mp="3rs726w4lw8yn">Diagnóstico • Fallas • Circuitos • Soluciones</p>

      <div className="mt-4" data-id="element-100" data-mp="lmgzt18fv9j">
        <CtaButton mode="scroll" data-id="element-101" data-mp="kum6kfgm1kb">¡Sí! Quiero el Combo Completo Electricistas</CtaButton>
      </div>
      <p className="mt-3 text-xs font-bold uppercase tracking-wide text-white" data-id="element-102" data-mp="5dnqx8axh9we">
        Accedé hoy a tu sistema completo de consulta profesional.
      </p>
      <p className="mx-auto mt-1 max-w-md text-xs font-bold uppercase leading-snug text-white/80" data-id="element-103" data-mp="edaspv7kkhpz">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-sky-400" aria-hidden data-id="element-104" data-mp="jd5j7xnfn5ai" />
            Garantía de devolución de 7 días •{' '}
          </>}
        4 tomos + 4 bonos • Acceso digital inmediato
      </p>
    </header>;
}